import { listOrgEnrollments } from "./enrollmentHelpers"
import { toMillis } from "./dateRangeHelpers"

const DAY_MS = 86400000

// v1 thresholds — a recency-based proxy standing in for the richer "at risk"
// scoring the product spec describes (stalled progress, repeated quiz
// failures, missed deadlines). Classification uses each learner's MOST
// RECENT lastActivityAt across all their enrollments in this org, not any
// single enrollment, so a learner active in one course doesn't get flagged
// inactive just because an older enrollment in another course is stale.
export const ACTIVE_WITHIN_DAYS = 7
export const AT_RISK_WITHIN_DAYS = 30

export const computeLearnerHealthBreakdown = async (orgId) => {
  const { enrollments } = await listOrgEnrollments(orgId)
  const now = Date.now()

  const lastActivityByUser = {}
  enrollments?.forEach((e) => {
    const ms = toMillis(e?.lastActivityAt)
    if (ms === null) return
    if (!lastActivityByUser[e?.userId] || ms > lastActivityByUser[e?.userId]) {
      lastActivityByUser[e?.userId] = ms
    }
  })

  const userIds = new Set(enrollments?.map((e) => e?.userId))
  let active = 0
  let atRisk = 0
  let inactive = 0

  userIds.forEach((userId) => {
    const lastMs = lastActivityByUser[userId]
    const daysSince = lastMs ? (now - lastMs) / DAY_MS : Infinity
    if (daysSince <= ACTIVE_WITHIN_DAYS) active += 1
    else if (daysSince <= AT_RISK_WITHIN_DAYS) atRisk += 1
    else inactive += 1
  })

  const total = userIds.size || 0
  const pct = (n) => (total > 0 ? Math.round((n / total) * 1000) / 10 : 0)

  return {
    total,
    active: { count: active, percent: pct(active) },
    atRisk: { count: atRisk, percent: pct(atRisk) },
    inactive: { count: inactive, percent: pct(inactive) },
  }
}